export const getTradeTotalCostSigned = (tradeAmount, transactionType) => {
    if (transactionType === 'expiration' || transactionType === 'assignment')
        return 0;
    if (transactionType === 'exercise' || transactionType === 'splitOut' || transactionType === 'splitIn') {
        if (tradeAmount !== 0)
            throw new Error(`${transactionType} marker trade amount must be zero: ${tradeAmount}`);
        return 0;
    }
    if (tradeAmount < 0)
        throw new Error(`Trade amount must be positive: ${tradeAmount}`);
    let tradeAmountSigned = tradeAmount;
    if (transactionType === 'buy' ||
        transactionType === 'buyToOpen' ||
        transactionType === 'buyToCover' ||
        transactionType === 'buyToClose' ||
        transactionType === 'assignmentBuy') {
        tradeAmountSigned = -tradeAmount;
    }
    else if (transactionType === 'sell' ||
        transactionType === 'sellToClose' ||
        transactionType === 'sellToOpen' ||
        transactionType === 'shortSell') {
        tradeAmountSigned = tradeAmount;
    }
    else {
        throw new Error(`Unknown trade type: ${transactionType}`);
    }
    return tradeAmountSigned;
};
//# sourceMappingURL=getTradeTotalCostSigned.js.map